import { useTranslator } from '@/hooks/useTranslator'

export function Translation({
	id,
	html,
	as: As,
	...params
}: {
	id: string
	html?: boolean
	as?: 'span' | 'p' | 'div'
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<string, any>) {
	const translator = useTranslator()

	const content = translator.translate(id, params)

	if (html) {
		if (!As) As = 'span'
		return (
			// eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
			<As
				data-translation={id}
				dangerouslySetInnerHTML={{ __html: content }}
			/>
		)
	} else if (As) {
		return <As data-translation={id}>{content}</As>
	} else {
		return content
	}
}
